



















































































































































































































































import { Component, Mixins } from 'vue-property-decorator';
import ContactInfo from '@rogues/ContactInfo/shared/contactInfo';

@Component
/**
 * @name Informed
 */
export default class Informed extends Mixins(ContactInfo) {
    responsive = {
        icon: {
            768: 'normal',
        },
    }

    /**
     * Hide item if exist in exclude list
     * 
     * @param {string} key
     * @returns {boolean}
     */
    excl(key: string): boolean {
        return !this.$props.exclude?.includes(key);
    }

    /**
     * Return link number
     * 
     * @param {string | number} tel
     * @param {string} type - type of number
     * @returns {string}
     */
    numberLink(tel: number, type:string = 'tel'): string {
        let num = this.digits(tel, 'en');
        if (String(num)[0] === String(0)) {
            num = String(num).slice(1);
        }
        
        num = String(num).replace('-', '');
        return `${type}:+98${this.digits(parseInt(num.toString(), 10), 'en')}`;
    }
}
